export default __webpack_public_path__ + "static/media/home.9a9b1be0.svg";